export default "__VITE_ASSET__Dss5PkEM__"